// authSlice.ts
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { getAllexperience, getExperience } from '../../services/Experience/experienceService';

//* Define the shape of the AuthState
type ExperienceState = {
  experiences: {
    data: any;
    isLoading: boolean;
    error: boolean;
  };
  experience: {
    data: any;
    isLoading: boolean;
    error: boolean;
  };
  inboxUser:null;
  availibility: null;
};

//* Set the initial state for the auth slice
const initialState: ExperienceState = {
  experiences: {
    data: null,
    isLoading: false,
    error: false,
  },
  experience: {
    data: null,
    isLoading: false,
    error: false,
  },
  inboxUser: null,
  availibility: null,
};

const experienceSlice = createSlice({
  name: 'experience',
  initialState,
  reducers: {
    resetExperience: (state) => {
      state.experience.data = null;
    },
    setInboxUser: (state, action: PayloadAction<any>) => {
       state.inboxUser = action.payload
    },
    resetInboxUser:(state)=>{
      console.log("reset user")
      state.inboxUser = null
    },
    setAvailability: (state, action: PayloadAction<any>) => {
      state.availibility = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExperience.pending, (state) => {
        state.experience.isLoading = true;
        state.experience.error = false;
      })
      .addCase(fetchExperience.fulfilled, (state, action: PayloadAction<any>) => {
        state.experience.isLoading = false;
        state.experience.data = action?.payload?.experience;
      })
      .addCase(fetchExperience.rejected, (state) => {
        state.experience.isLoading = false;
        state.experience.error = true;
      })
      .addCase(fetchAllExperience.pending, (state) => {
        state.experiences.isLoading = true;
        state.experiences.error = false;
      })
      .addCase(fetchAllExperience.fulfilled, (state, action: PayloadAction<any>) => {
        state.experiences.isLoading = false;
        state.experiences.data = action.payload.experiences;
      })
      .addCase(fetchAllExperience.rejected, (state) => {
        state.experiences.isLoading = false;
        state.experiences.error = true;
      });
  }
});

// handle async operation
export const fetchExperience = createAsyncThunk(
  'experience/fetchExperience',
  async ({ experienceID }: { experienceID: string },  thunkAPI) => {
    try {
      const response = await getExperience(experienceID);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
)

export const fetchAllExperience = createAsyncThunk(
  'experience/fetchAllExperience',
  async (arg: any, thunkAPI: any) => {
    try {
      const response = await getAllexperience();
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
)


//* Extract the action creator(s) and reducer from the slice
export const {
  resetExperience,
  setInboxUser,
  setAvailability,
  resetInboxUser
} = experienceSlice.actions;

//* Export the entire slice, which includes the reducer
export default experienceSlice.reducer;
export const selectInboxUser = (state:RootState)=>state.experience.inboxUser